<template>
    <div id="edicaoVencedoresLicitacao" v-if="lic.IdLicitacao">
        <editar-dados-homologacao-licitacao :lic="lic"
            @atualizarLicitacao="atualizarLicitacao"></editar-dados-homologacao-licitacao>
        <b-row>
            <b-card class="w-100 " no-body>
                <template #header>
                    <h5
                        class="mb-0 titulo-mobile d-flex flex-column flex-md-row justify-content-between align-items-center">
                        {{ tituloTabela }}
                        <modal-editar-itens-por-vencedor v-if="!lic.IsLote" :idLicitacao="lic.IdLicitacao" />
                        <busca-tabela v-if="!lic.IsLote" @busca="recarregarVencedores" />
                    </h5>
                </template>
                <editar-vencedores-lote-table v-if="lic.IsLote" :licitacao="lic" />
                <editar-vencedores-item-table v-else-if="!loadUpdate" :licitacao="lic" :textoFiltro="buscaNome" />
                <b-spinner v-else class="align-middle"></b-spinner>
            </b-card>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

import EditarVencedoresLoteTable from '@/components/licitacoes/ldi/editar-ldi/EditarVencedoresLoteTable.vue'
import EditarVencedoresItemTable from '@/components/licitacoes/ldi/editar-ldi/EditarVencedoresItemTable.vue'
import EditarDadosHomologacaoLicitacao from '@/components/licitacoes/ldi/editar-ldi/EditarDadosHomologacaoLicitacao.vue'
import BuscaTabela from '@/components/shared/BuscaTabela.vue'
import ModalEditarItensPorVencedor from '@/components/licitacoes/ldi/modais/ModalEditarItensPorVencedor.vue'


const CompProps = Vue.extend({
    name: 'AbaEditarVencedores',
    components: { BuscaTabela, EditarVencedoresItemTable, EditarDadosHomologacaoLicitacao, EditarVencedoresLoteTable, ModalEditarItensPorVencedor },
    props: {
        lic: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarVencedores extends mixins(UtilsTS, CompProps) {
    loadUpdate = false
    buscaNome = ''

    get tituloTabela() {
        return this.lic.IsLote ? 'Lotes' : 'Itens'
    }

    async atualizarLicitacao() {
        this.loadUpdate = true
        try {
            this.$emit('atualizarLicitacao', null)
            await new Promise(r => setTimeout(r, 100));
        } finally {
            this.loadUpdate = false
        }
    }

    async recarregarVencedores(filtro: string): Promise<void> {
        this.loadUpdate = true
        try {
            this.buscaNome = filtro
            await new Promise(r => setTimeout(r, 100));
        } finally {
            this.loadUpdate = false
        }
    }
}
</script>

<style scoped></style>